'use client';

import { useEffect, useState } from 'react';
import { ANALYTICS_CONSENT_EVENT, hasAnalyticsConsent } from '@/lib/analyticsConsent';

export function useAnalyticsConsent(): boolean {
  const [consented, setConsented] = useState(false);

  useEffect(() => {
    setConsented(hasAnalyticsConsent());

    const handleChange = () => setConsented(hasAnalyticsConsent());
    window.addEventListener(ANALYTICS_CONSENT_EVENT, handleChange);
    window.addEventListener('storage', handleChange);
    return () => {
      window.removeEventListener(ANALYTICS_CONSENT_EVENT, handleChange);
      window.removeEventListener('storage', handleChange);
    };
  }, []);

  return consented;
}
